import React, { useState, useEffect, useRef } from "react";

//-----------------------Reuseable-----------------------//
import ToggleCell from "../reuseable/ToggleCell";
//-----------------------Libiraries-----------------------//
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import Modal from "react-modal";
import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import "jspdf-autotable";
//-----------------------Images-----------------------//
import noImage from "../assets/images2/NoImage.svg";
import editImage from "../assets/images2/editColored.svg";
import editImagedisable from "../assets/images2/editDisable.svg";
import trash from "../assets/images2/trash.svg";
import Search from "../assets/images2/Search.svg";
import close from "../assets/images2/Close.svg";
import star from "../assets/images2/star.svg";
import del from "../assets/images/Delete.svg";
import delDisable from "../assets/images/trashDisable.svg";
import eye from "../assets/images/Eye.svg";
import addDisable from "../assets/images/addPlus.svg";

import calender from "../assets/images2/calender.svg";
import add from "../assets/images/AddColored.svg";
import filterSvg from "../assets/images2/filter.svg";
import pdfImr from "../assets/images2/EnablePdf.svg";
import disablepdfImr from "../assets/images2/DisablePdf.svg";
import printImr from "../assets/images2/printImr.svg";
import printImrDisable from "../assets/images2/printImrDisable.svg";

import ok from "../assets/images/Ok.svg";
import Add from "../assets/images/AddColoredTable.svg";
import starFill from "../assets/images/StarFill.svg";
import filter from "../assets/images/filterSearch.svg";
import filter2 from "../assets/images/filterSearchPlus.svg";
import inProgress from "../assets/images/inprogress.svg";

import moment from "moment";
import { ImCancelCircle } from "react-icons/im";

import "../App.css";
//-----------------------Dummy-Data-----------------------//
import { data003 } from "../reuseable/DummyArrayImrProducts";
import { dummyArray } from "../reuseable/DummyArray";
import { dummyArray2 } from "../reuseable/DummyArrayTwo";
//-----------------------Header-Footer-----------------------//
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import { FaSort } from "react-icons/fa";
import secureLocalStorage from "react-secure-storage";
import { Puff } from "react-loader-spinner";
import Routes from "./Components/data/remote/Routes";
import addDisble from "../assets/images/AddDisable.svg";
import { Tooltip } from "react-tooltip";
import ReactToPrint from "react-to-print";
import { UnAuthModal } from "../reuseable/UnAuthModal";
import { checkAuth } from "../reuseable/UnAuthFunction";

Modal.setAppElement("#root");

const customSortIcon = (sortDirection) => {
  if (sortDirection === "asc") {
    return <FaSort className="" />;
  } else if (sortDirection === "desc") {
    return <FaSort className="" />;
  } else {
    return null;
  }
};
const ViewImr = () => {
  const columns = [
    {
      id: 1,
      name: "Material Code",
      selector: (row) => row?.material_code,
      sortable: true,
    },
    {
      id: 2,
      name: "Material Category",
      selector: (row) => row?.material_category,
      sortable: true,
    },
    {
      id: 3,
      name: "Class",
      selector: (row) => row?.class,
      sortable: true,
    },
    {
      id: 4,
      name: "Short Text",
      selector: (row) => row?.short_text,
      sortable: true,
    },
    {
      id: 5,
      name: "Long Text",
      selector: (row) => row?.long_text,
      sortable: true,
    },
    {
      id: 6,
      name: "UoM",
      selector: (row) => row?.UOM,
      sortable: true,
    },
    {
      id: 7,
      name: "Manufacturer",
      selector: (row) => row?.manufacturer,
      sortable: true,
    },
    {
      id: 8,
      name: "Manufacturing Model",
      selector: (row) => row?.manufacturer_model,
      sortable: true,
    },

    {
      id: 9,
      name: "Select Items",
      cell: (row) => (
        <>
          {data4?.some((item2) => item2?.material?.id === row.id) ? (
            <img
              className="ms-1"
              style={{ width: "28px" }}
              src={addDisble}
              alt="Add"
            />
          ) : data4?.some((item) => item.id === row.id) ? (
            <img
              style={{ cursor: "pointer" }}
              onClick={() => handleToggle(row)}
              src={ok}
              alt="ok"
            />
          ) : (
            <img
              style={{ cursor: "pointer" }}
              onClick={() => handleToggle(row)}
              src={Add}
              alt="Add"
              className=" my-element"
              data-tooltip-content="Add Request"
            />
          )}
        </>
      ),
    },
  ];
  //2

  //states
  const [showTable, setShowTable] = useState(false);
  const [showTableTwo, setShowTableTwo] = useState(false);
  const [wordCount, setWordCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editedRow, setEditedRow] = useState(null);
  const [fileInputs, setFileInputs] = useState([{ id: 0, file: null }]);
  const [imrDataTable, setImrTableData] = useState([]);
  const [saveImr, setSaveImr] = useState(false);
  const [releaseImr, setReleaseImr] = useState(false);
  const [approved, setApproved] = useState(false);
  const [reject, setReject] = useState(false);
  const [resubmit, setResubmit] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState();

  const [createPr, setCreatePr] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [CurrentData, setCurrntDate] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewFile, setPreviewFile] = useState(null);

  const [inputValue, setInputValue] = useState("");
  const [filteredData2, setFilteredData2] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);
  const [boleanVal, setBolean] = useState();
  const [action, setAction] = useState();

  const [selectedRows, setSelectedRows] = useState([]);
  const [file, setFile] = useState([]);
  const [showFullText, setShowFullText] = useState(false);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [page3, setPage3] = useState(0);
  const [perPage3, setPerPage3] = useState(25);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [searchMaterial, setSearchMaterial] = useState([]);
  const [filterCountries, setFilterCountries] = useState();
  const [filterCountries2, setFilterCountries2] = useState([]);

  const [selectedOption3, setSelectedOption3] = useState(null);
  const [data4, setdata4] = useState([]);
  const [disableEditButton, setDisableEditButton] = useState(true);
  const [editApiEnable, setEditApiEnable] = useState(false);
  const [releaseStatus, setReleaseStatus] = useState();
  const [fileNames, setFileNames] = useState([]);
  const [fileName, setFileName] = useState("");
  const [projectId, setProjectId] = useState();
  const [level, setLevel] = useState(0);
  const [search, setSearch] = useState("");
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const navigate = useNavigate();
  const [materialId, setMaterialId] = useState("");
  const [urlArray, setUrlArray] = useState([]);
  const [firstName, setFirstName] = useState(
    secureLocalStorage.getItem("first_name")
  );
  const [lastName, setLastName] = useState(
    secureLocalStorage.getItem("last_name")
  );
  const [userComment, setUserComment] = useState("");
  const [userFirstName, setUserFirstName] = useState("");
  const [userLastName, setUserLastName] = useState("");
  const [releasedCondition, setIsReleasedCondition] = useState("");
  // api section
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [selectedImageArray, setSelectedImageArray] = useState("");
  const [editingRow, setEditingRow] = useState(null);
  const [editedValues, setEditedValues] = useState({});
  const [userEnteredData, setUserEnteredData] = useState([]);
  const [ceateprojectId, setCreateProjectId] = useState("");
  const [imrNumber, setImrNo] = useState("");
  const [role, setRole] = useState("");
  const [requiredDeliveryDate, setRequiredDeliveryDate] = useState([]);

  const [currentLevel, setCurrentLevel] = useState("");
  const [commentDate, setCommentDate] = useState();
  const [commentTime, setCommentTime] = useState();
  const [totalLevel, setTotalLevel] = useState("");
  const [requestId, setRequestId] = useState("");
  const [status, setStatus] = useState("");
  const [imrDate, setImrDate] = useState("");
  const [imrTime, setImrTime] = useState("");

  const [posts, setPosts] = useState("");
  const [showInputFields, setShowInputFields] = useState(false);
  const [createIMRRequest, setCreateImr] = useState();
  const [textAreaValue, setTextAreaValue] = useState("");
  const [editedNames, setEditedNames] = useState({}); // new state object to hold the edited name value for each row
  const [editedAges, setEditedAges] = useState({}); // new state object to hold the edited age value for each row
  const [editedEmails, setEditedEmails] = useState({}); // new state object to hold the edited email value for each row
  const [editedDobs, setEditedDobs] = useState({}); // new state object to hold the edited dob value for each row
  const [names, setNames] = useState(data4.map((row) => row?.quantity));
  const [dobs, setDobs] = useState(data4.map((row) => row?.delivary_date));
  const [emails, setEmails] = useState(data4.map((row) => row?.wbs_element));
  const [stockLoation, setStokeLocation] = useState();
  const [matchRqstLevel, setMatchRqstLevel] = useState([]);
  const [stockQty, setStockQty] = useState();
  const [releaseArray, setReleaseArray] = useState([]);
  const dropdownRef2 = useRef(null);
  const [selectedOptions2, setSelectedOptions2] = useState([]); // Update state to an array to store multiple selected options
  const [numSelectedOptions2, setNumSelectedOptions2] = useState(0);
  const [selectedOption2, setSelectedOption2] = useState("");
  const [deletedImagesId, setdeletedImagesId] = useState([]);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [deleteFile, setDeleteFile] = useState(false);

  const [selectedMaterialCode, setSelectedMaterialCode] = useState(null);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedShortText, setSelectedShortText] = useState(null);
  const [modalIsOpen, setIsOpen4] = useState(false);
  const [modalIsOpen5, setIsOpen5] = useState(false);
  const componentRef = useRef();
  const userID = secureLocalStorage.getItem("userLevel");

  let subtitle;
  const columns2 = [
    {
      id: 1,
      name: "Item no",
      selector: (row, index) => page3 * perPage3 + index + 1,
      sortable: true,
    },
    {
      id: 2,
      name: "Material Type",
      selector: (row) =>
        row?.material?.material_type
          ? row?.material?.material_type
          : row?.material_type,
      sortable: true,
    },
    {
      id: 3,
      name: "Material Category",
      selector: (row) =>
        row?.material?.material_category
          ? row?.material?.material_category
          : row?.material_category,
      sortable: true,
    },
    {
      id: 4,
      name: "Material Code",
      selector: (row) =>
        row?.material?.material_code
          ? row?.material?.material_code
          : row?.material_code,
      sortable: true,
    },
    {
      id: 5,
      name: "Short Text",
      selector: (row) =>
        row?.material?.short_text ? row?.material?.short_text : row?.short_text,
      sortable: true,
    },
    {
      id: 6,
      name: "Long Text",
      selector: (row) =>
        row?.material?.long_text ? row?.material?.long_text : row?.long_text,
      sortable: true,
    },
    {
      id: 7,
      name: (
        <div className="tableHeaders">
          <span className="quantitySpan" style={{ color: "red" }}>
            *
          </span>{" "}
          Quantity
        </div>
      ),
      selector: (row) => row?.quantity,
      sortable: true,
      cell: (row) => {
        const editedValue = editedValues[row.id]?.quantity;
        if (!row.quantity && editingRow !== row.id) {
          return (
            <div
              className="placeholderText"
              onClick={() => setEditingRow(row.id)}
            >
              Enter quantity
            </div>
          );
        }
        return (
          <div onClick={() => setEditingRow(row.id)}>
            {editingRow === row.id ? (
              <input
                type="number"
                value={editedValue || row.quantity}
                placeholder="Enter quantity"
                className="onFocusInput"
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => {
                  const newValue = parseInt(e.target.value);
                  if (newValue >= 0) {
                    setEditedValues({
                      ...editedValues,
                      [row.id]: {
                        ...editedValues[row.id],
                        quantity: newValue,
                      },
                    });
                  }
                }}
                onBlur={handleSave}
                min={0} // set the minimum value to 0
              />
            ) : (
              editedValue || row.quantity
            )}
          </div>
        );
      },
    },
    {
      id: 8,
      name: "Unit",
      selector: (row) =>
        row?.material?.unit ? row?.material?.unit : row?.unit,
      sortable: true,
    },

    {
      id: 9,
      selector: (row) => row?.delivary_date,
      name: (
        <div className="tableHeaders">
          <span className="quantitySpan" style={{ color: "red" }}>
            *
          </span>{" "}
          Required delivery date
        </div>
      ),
      sortable: true,
      cell: (row) => {
        const editedValue = editedValues[row.id]?.delivary_date;
        const currentValue =
          editedValues[row.id]?.delivary_date || row.delivary_date;
        const handleChange = (e) => {
          if (e == null) {
            row.delivary_date = null;
          }
        };
        const handleBlur = () => {
          if (
            currentValue !== row.delivary_date ||
            currentValue === "" ||
            currentValue === undefined
          ) {
            handleSave();
          }
        };
        const handleSelect = (date) =>
          setEditedValues({
            ...editedValues,
            [row.id]: {
              ...editedValues[row.id],
              delivary_date: moment(date).format("YYYY-MM-DD"),
            },
          });
        if (!row.delivary_date && editingRow !== row.id) {
          return (
            <div
              className="placeholderText"
              onClick={() => setEditingRow(row.id)}
            >
              Select Date
            </div>
          );
        }
        return (
          <div
            className="position-relative"
            onClick={() => setEditingRow(row.id)}
          >
            {/* {console.log('object', editedValue, row.delivary_date)} */}
            {editingRow === row.id ? (
              <DatePicker
                placeholder="Enter Date"
                className="onFocusInput"
                placeholderText="Select Date"
                // selected={
                //     editedValue
                //         ? moment(editedValue, "YYYY-MM-DD").toDate()
                //         : null
                // }

                selected={
                  editedValue
                    ? moment(editedValue, "YYYY-MM-DD").toDate()
                    : row.delivary_date
                      ? moment(row.delivary_date, "YYYY-MM-DD").toDate()
                      : null
                }
                dateFormat="dd-MM-yyyy"
                // onChange={(e) => handleChange(e)}
                onSelect={handleSelect}
                onBlur={handleBlur}
                minDate={moment().add(7, "days").toDate()}
              // maxDate={moment().add(14, 'days').toDate()} // optional: limit selection to 7-14 days after current date
              />
            ) : (
              editedValue || moment(row.delivary_date).format("DD-MM-YYYY")
            )}
          </div>
        );
      },
    },

    {
      id: 10,
      name: "Manufacturer",
      selector: (row) =>
        row?.material?.manufacturer
          ? row?.material?.manufacturer
          : row?.manufacturer,
      sortable: true,
    },
    {
      id: 11,
      name: "Manufacturing Model",
      selector: (row) =>
        row?.material?.manufacturer_model
          ? row?.material?.manufacturer_model
          : row?.manufacturer_model,
      sortable: true,
    },
    {
      id: 12,
      selector: (row) => row?.wbs_element,
      sortable: true,
      // name: 'WBS Elements',

      name: (
        <div className="tableHeaders">
          <span className="quantitySpan" style={{ color: "red" }}>
            *
          </span>{" "}
          WBS Element
        </div>
      ),
      cell: (row) => {
        const editedValue = editedValues[row.id]?.wbs_element;
        if (!row.wbs_element && editingRow !== row.id) {
          return (
            <div
              className="placeholderText"
              onClick={() => setEditingRow(row.id)}
            >
              Enter WBS Element
            </div>
          );
        }
        return (
          <div onClick={() => setEditingRow(row.id)}>
            {editingRow === row.id ? (
              <input
                type="text"
                className="onFocusInput"
                placeholder="Enter WBS Element"
                value={editedValue || row.wbs_element}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) =>
                  setEditedValues({
                    ...editedValues,
                    [row.id]: {
                      ...editedValues[row.id],
                      wbs_element: e.target.value,
                    },
                  })
                }
                onBlur={handleSave}
              />
            ) : (
              editedValue || row.wbs_element
            )}
          </div>
        );
      },
    },

    {
      id: 13,
      name: "Plant",
      selector: (row) =>
        row?.material?.plant ? row?.material?.plant : row?.plant,
      sortable: true,
    },
    {
      id: 14,
      name: "Stock Available Location",
      selector: (row) =>
        row?.stock_location ? row?.stock_location : row?.stock,
      cell: (row) => (
        <div className="showTwoText list-item">
          {/* {row?.stock_location ? (
                        <ol style={{ listStyleType: "disc" }}>
                            {row?.stock_location.split(",").map((location) => (
                                <li key={location}>{location.trim()}</li>
                            ))}
                        </ol>
                    ) : (
                        <ol style={{ listStyleType: "disc" }}>
                            {row?.stock?.map((item) => {
                                return <li>{item.location}</li>;
                            })}
                        </ol>
                    )} */}

          <div className="showTwoText list-item">
            <img
              style={{
                display: "block",
                margin: "auto",
                cursor: "pointer",
                width: 25,
                height: "auto",
                textTransform: "capitalize",
              }}
              data-tooltip-content="This Feature Will Be Implemented In Next Iteraion"
              className=" my-element"
              src={inProgress}
              alt="inProgress"
            />
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      id: 15,
      name: "Stock Available Qty",
      selector: (row) =>
        row?.stock_quantity ? row?.stock_quantity : row?.stock,

      cell: (row) => (
        <div className="showTwoText list-item">
          {/* {row?.stock_quantity ? (
                        <ol style={{ listStyleType: "none" }}>
                            {row?.stock_quantity.split(",").map((location) => (
                                <li key={location}>{location.trim()}</li>
                            ))}
                        </ol>
                    ) : (
                        <ol style={{ listStyleType: "none" }}>
                            {row?.stock?.map((item) => {
                                return <li>{item.quantity}</li>;
                            })}
                        </ol>
                    )} */}
          <div className="showTwoText list-item">
            <img
              style={{
                display: "block",
                margin: "auto",
                cursor: "pointer",
                width: 25,
                height: "auto",
                textTransform: "capitalize",
              }}
              data-tooltip-content="This Feature Will Be Implemented In Next Iteraion"
              className=" my-element"
              src={inProgress}
              alt="inProgress"
            />
          </div>
        </div>
      ),
      sortable: true,
    },

    {
      id: 16,
      name: "Quick Actions",
      button: true,
      sortable: false,
      omit: role !== "Approver" ? false : true,
      cell: (row) => {
        if (editingRow === row.id) {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{ cursor: "pointer", fontSize: "25px" }}
                onClick={() => {
                  const index = data4?.findIndex((r) => r?.id === row?.id);
                  const newData = [...data4];
                  newData[index] = { ...newData[index], ...editedValues };
                  setdata4(newData);
                  setEditingRow(null);
                  setEditedValues({});
                  setEditedNames({
                    ...editedNames,
                    [row.id]: undefined, // reset the edited name value for the row
                  });
                  setEditedAges({
                    ...editedAges,
                    [row.id]: undefined, // reset the edited age value for the row
                  });
                  setEditedEmails({
                    ...editedEmails,
                    [row.id]: undefined, // reset the edited email value for the row
                  });
                  setEditedDobs({
                    ...editedDobs,
                    [row.id]: undefined, // reset the edited dob value for the row
                  });
                  // }
                }}
              >
                {/* <BiSave /> */}
              </div>
              <div
                style={{
                  fontSize: "23px",
                  marginLeft: "5px",
                  cursor: "pointer",
                }}
                className=" my-element"
                data-tooltip-content="Cancel"
                onClick={() => setEditingRow(null)}
              >
                <ImCancelCircle />
              </div>
            </div>
          );
        }
        return (
          <div className="d-flex align-items-center justify-content-center">
            <div>
              {status == "Rejected" ||
                role == "Approver" ||
                role == "Viewer" ||
                status == "Approved" ||
                (role == "User" && action == 1) ||
                status == "pending" ||
                releaseImr ? (
                <img
                  style={{ width: "25px" }}
                  className="editImageIcon"
                  src={editImagedisable}
                  alt="editImagedisable"
                />
              ) : (
                <img
                  className="editImageIcon my-element"
                  data-tooltip-content="Edit Request"
                  onClick={() => {
                    setEditingRow(row.id);
                    setEditApiEnable(true);
                  }}
                  src={editImage}
                  alt="editImage"
                />
              )}
            </div>
            {status == "Rejected" ||
              role == "Approver" ||
              role == "Viewer" ||
              status == "Approved" ||
              (role == "User" && action == 1) ||
              status == "pending" ||
              releaseImr ? (
              <img className="editImageIcon" src={delDisable} alt="trash" />
            ) : (
              <img
                onClick={() => {
                  openModal5();
                  setDeleteRowId(row?.id);
                }}
                className="editImageIcon my-element"
                data-tooltip-content="Delete Request"
                src={trash}
                alt="trash"
              />
            )}

            {modalIsOpen5 ? (
              <div className="deleteAccountMain">
                <Modal
                  isOpen={modalIsOpen5}
                  onAfterOpen={afterOpenModal5}
                  onRequestClose={closeModal5}
                  style={customStyles}
                  contentLabel="Example Modal"
                >
                  <div className="delModelHeader">
                    <h2>Delete Confirmation</h2>
                    <div class="horizontal-line"></div>
                    <p>Are you sure you want to delete this material?</p>
                    <div className="modal-button">
                      <button
                        onClick={() => handleDelete(row)}
                        className="delAccountOkButton d-flex align-items-center justify-content-center"
                      >
                        Ok
                      </button>
                      <button
                        onClick={closeModal5}
                        className="delAccountCancelButton d-flex align-items-center justify-content-center"
                      >
                        cancel
                      </button>
                    </div>
                  </div>
                </Modal>
              </div>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
  ];

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "15px",
    },
  };

  function openModal() {
    if (selectedRows?.length === 0) {
      return notify("Please select one or more rows to delete", "error");
    } else {
      setIsOpen4(true);
    }
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  }
  function closeModal() {
    setIsOpen4(false);
  }

  function openModal5() {
    setIsOpen5(true);
  }
  function afterOpenModal5() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  }
  function closeModal5() {
    setIsOpen5(false);
  }
  useEffect(() => {
    checkAuth();

    if (!accessToken) {
      history("/");
    }
  }, []);
  useEffect(() => {
    const checkData = data4.map((row) => row?.stock?.length);
    setNames(data4.map((row) => row?.quantity));
    setDobs(data4.map((row) => row?.delivary_date));
    setEmails(data4.map((row) => row?.wbs_element));
    setStokeLocation(
      data4.map((row) => {
        if (row.stock && row.stock.length) {
          return row.stock.map((item) => item.location);
        } else {
          return row.stock_location ? [row.stock_location] : null;
        }
      })
    );
    setStockQty(
      data4.map((row) => {
        if (row.stock && row.stock.length) {
          return row.stock.map((item) => item.quantity);
        } else {
          return row.stock_location ? [row.stock_location] : null;
        }
      })
    );
  }, [data4]);
  //section end
  const dropdownRef = useRef(null);
  const handleSort = (column, sortDirection) => {
    setSortColumn(column.selector);
    setSortDirection(sortDirection);
  };

  // Listen for a "back" button press
  useEffect(() => {
    checkAuth();
    const handleBackButton = (event) => {
      event.preventDefault();
      setEditedValues({});
      setEditingRow(null);
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  useEffect(() => {
    validate();
  }, [editedValues]);

  const validate = () => {
    const errors = {};
    let hasErrors = false; // Initialize hasErrors variable

    data4?.forEach((row) => {
      // Check if Quantity field is empty
      if (!row.quantity) {
        errors[row.id] = {
          ...errors[row.id],
          quantity: "Required field",
        };
      }
      // Check if Required delivery date field is empty
      if (!row.delivary_date) {
        errors[row.id] = {
          ...errors[row.id],
          delivary_date: "Required field",
        };
      }
      // Check if WBS Element field is empty
      if (!row.wbs_element) {
        errors[row.id] = {
          ...errors[row.id],
          wbs_element: "Required field",
        };
      }
    });

    hasErrors = Object.keys(errors).length > 0; // Check if there are any errors

    // Check if all required fields are filled in and there are no errors
    const allFieldsFilled = data4?.every(
      (row) => row?.quantity && row?.delivary_date && row?.wbs_element
    );
    setIsSaveEnabled(!hasErrors && allFieldsFilled); // Enable/disable save button

    return errors;
  };

  const history = useNavigate();

  const accessToken = secureLocalStorage.getItem("token");

  const FetchProjects = () => {
    setLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + accessToken);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(Routes.PROJECTS, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setProjects(result?.data[0]);
        setLoading(false);
      })
      .catch((error) => {
        // console.log("error", error);
        setLoading(false);
      });
  };

  const handleOptionClick = (option) => {
    if (selectedOptions2.includes(option)) {
      // If option is already selected, remove it from selectedOptions2 array
      setSelectedOptions2(
        selectedOptions2.filter((selectedOption) => selectedOption !== option)
      );
    } else {
      // If option is not selected, add it to selectedOptions2 array
      setSelectedOptions2([...selectedOptions2, option]);
    }

    if (!selectedOptions2.includes(option)) {
      setSelectedOptions2([...selectedOptions2, option]);
      setNumSelectedOptions2(numSelectedOptions2 + 1);
    }
  };

  let selectedIcons = null;
  if (selectedOptions2.length > 0) {
    selectedIcons = selectedOptions2.map((option, index) => (
      <img key={index} src={filter} alt="filter" />
    ));
  }

  const FilterMethod = () => {
    const filteredList = filteredData2.filter((item) => {
      if (selectedOptions2.length === 0) {
        return true; // If no options are selected, return all items
      } else {
        // Check if any of the selected options match the current item's property
        return selectedOptions2.some((option) => {
          if (option === "Material Description") {
            return item.long_text
              .toLowerCase()
              .includes(inputValue.toLowerCase());
          } else if (option === "Category") {
            return item.material_category
              .toLowerCase()
              .includes(inputValue.toLowerCase());
          } else if (option === "Material Code") {
            return item.material_code
              .toLowerCase()
              .includes(inputValue.toLowerCase());
          }
          return false;
        });
      }
    });
    return filteredList;
  };

  const FetchMaterialSearch = (keyword) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + accessToken);
    var formdata = new FormData();
    formdata.append("keyword", keyword);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    return fetch(
      "https://alhikmahinternational.org/al-asab/public/api/material/search",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => result?.data)
      .catch((error) => console.log("error", error));
  };

  const SinglrRequest = async (requestId) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + accessToken);

    var formdata = new FormData();
    formdata.append("request_id", requestId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        "https://alhikmahinternational.org/al-asab/public/api/IMR/request",
        requestOptions
      );
      const result = await response.json();
      // console.log('resultSigleRequest--->', result);
      setIsReleasedCondition(result?.data?.is_released);
      setUserFirstName(result?.data?.created_by?.first_name);
      setUserLastName(result?.data?.created_by?.last_name);
      setdata4(result?.data?.materials);
      setUrlArray(result?.data?.documents);
      setCurrentLevel(result?.data?.current_level);
      setCreateProjectId(result?.data?.projects?.id);
      setProjectId(result?.data?.projects?.id);
      setStatus(result?.data?.stage);
      setImrNo(result?.data?.request_prefix);

      setTotalLevel(result?.data?.projects?.no_of_approval_level);
      setSelectedOption(result?.data?.projects);
      handleOptionSelect(result?.data?.projects); // Call the function to update state
      setUserComment(result?.data?.comments);

      const originalDate = result?.data?.created_at;
      const updateDate = result?.data?.comments[0].updated_at;
      const formattedDate = moment(originalDate).format("DD-MM-YYYY");
      const formattedTime = moment(originalDate).format("HH:mm:ss");
      const commentDate = moment(updateDate).format("DD-MM-YYYY");
      const commentTime = moment(updateDate).format("HH:mm:ss");

      setCommentDate(commentDate);
      setImrDate(formattedDate);
      setImrTime(formattedTime);
      setCommentTime(commentTime);
      // setMaterialId(data?.material?.id)
      const materialIdsArray = result?.data?.materials?.map(
        (material) => material?.material_id
      );
      setMaterialId(materialIdsArray);
      // Convert the documents array into an array of File objects
      const selectedImageArray = await Promise.all(
        result?.data?.documents.map(async (document) => {
          const response = await fetch(document.url);
          const blob = await response.blob();
          return new File([blob], document.name, { type: blob.type });
        })
      );
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleInputChange = async (event) => {
    // setShowTable(false);
    const inputValue = event.target.value;
    setInputValue(inputValue);
    setPage(0);

    if (selectedOption2 === "Filter Image") {
      // assume you have a function to remove the value from your data source
      // and update the filteredData2 accordingly
      const filteredDataWithoutValue = filteredData2.filter((item) => {
        return item.long_text.toLowerCase() !== inputValue.toLowerCase();
      });
      setFilteredData2(filteredDataWithoutValue);

      setInputValue("no record found");
      return;
    }

    const searchResult = await FetchMaterialSearch(inputValue);
    setSearchMaterial(searchResult);
    // filter the data based on user input
    const filteredData2 = searchResult.filter((item) => {
      const matchesMaterial = item.material_code
        .toLowerCase()
        .includes(inputValue.toLowerCase());
      const matchesMaterialDesc = item.long_text
        .toLowerCase()
        .includes(inputValue.toLowerCase());
      const matchesLanguage = item.material_category
        .toLowerCase()
        .includes(inputValue.toLowerCase());
      return matchesMaterial || matchesMaterialDesc || matchesLanguage;
    });
    setFilteredData2(filteredData2);
    setIsOpen(inputValue !== "");
  };

  useEffect(() => {
    if (!search) {
      setFilterCountries(filterCountries2);
    } else {
      const result = filterCountries.filter((item) =>
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase())
      );
      setFilterCountries(result);
    }
  }, [search]);

  const handleMaterialCodeAccordionItemClick = (item) => {
    setSelectedMaterialCode(item);
    // Update state for all filters
    setSelectedClass("");
    setSelectedShortText("");
  };

  const handleClassAccordionItemClick = (item) => {
    setSelectedClass(item);
    // Update state for all filters
    setSelectedMaterialCode("");
    setSelectedShortText("");
  };

  const handleShortTextAccordionItemClick = (item) => {
    setSelectedShortText(item);
    // Update state for all filters
    setSelectedMaterialCode("");
    setSelectedClass("");
  };
  const handleIconClick = () => {
    setIsOpen2(!isOpen2);
  };

  const ReleaseButtonMethod = (level) => {
    const buttons = [];
    for (let index = 0; index < level; index++) {
      if (status === "Rejected") {
        buttons.push(
          <button disabled className="releaseDisableISR-btn">
            Release {index + 1}
          </button>
        );
      } else if (
        status === "Approved" ||
        releasedCondition == "1" ||
        role == "Viewer"
      ) {
        buttons.push(
          <button disabled className="releaseDisableISR-btn">
            Release {index + 1}
          </button>
        );
      } else if (!releaseImr && !createPr && isSaveEnabled) {
        if (index === parseInt(currentLevel) - 1) {
          // subtract 1 to match array index
          buttons.push(
            <button
              // disabled={!isSaveEnabled}
              onClick={() => releaseImrMethod()}
              className="releaseISR-btn"
            >
              Release {index + 1}
            </button>
          );
        } else {
          buttons.push(
            <button disabled className="releaseDisableISR-btn">
              Release {index + 1}
            </button>
          );
        }
      } else {
        buttons.push(
          <button
            disabled
            onClick={() => releaseImrMethod()}
            className="releaseDisableISR-btn"
          >
            Release {index + 1}
          </button>
        );
      }
    }

    return buttons;
  };

  useEffect(() => {
    checkAuth();
    window.scrollTo(0, 0);

    if (!accessToken) {
      history("/");
    } else {
      FetchProjects();
    }
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  const handleChangeRowsPerPage = (event) => {
    setPerPage3(Number(event.target.value));
    setPage3(0); // Reset to first page
  };

  const handleToggle = (row) => {
    setSaveImr(!saveImr);
    const foundRow = data4.find((item) => item.id === row.id);

    if (foundRow) {
      setdata4(data4.filter((item) => item.id !== row.id)); // remove selected row from data4
      setMaterialId(materialId.filter((id) => id !== row.id));
    } else {
      const isAlreadyAdded = data4.some(
        (item) => item?.material?.id === row.id
      );

      if (isAlreadyAdded) {
        notify("This row already exists in the table!", "error");
      } else {
        setdata4([...data4, row]); // add selected row to data4
        setMaterialId((prevMaterialId) => {
          const index = prevMaterialId.indexOf(row?.id - 1);
          if (index !== -1) {
            // Replace the previous value with the new one
            prevMaterialId.splice(index, 1, row?.id - 1);
            return prevMaterialId;
          } else {
            // Add the new value to the array
            return [...prevMaterialId, row?.id];
          }
        });
      }
    }

    const img = document.getElementById(`toggle-img-${row.id}`);
    const foundRowIndex = data4.findIndex((item) => item.id === row.id);
    if (foundRowIndex === -1) {
      img.src = Add; // Set the image source to the plus image
      img.alt = "Add"; // Set the alt text to "Add"
    } else {
      img.src = ""; // Remove the image source
      img.alt = ""; // Remove the alt text
    }
  };

  const longText =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed et augue quis massa convallis tristique eu vel ipsum. Donec pulvinar, sem et suscipit euismod, felis est ultricies magna, eget interdum metus lorem eget magna. Vestibulum vel lectus vel ex maximus posuere. Nullam vel elit massa. Nullam eu nisi gravida, vehicula ipsum et, posuere eros. Suspendisse potenti. Duis in feugiat lectus, eu pharetra felis. Sed eget lacus dui. Fusce eget enim mi.";

  //funtions
  function handlePreviewClick(previewUrl, index, names) {
    // console.log("name", names, index, previewUrl);
    if (previewUrl) {
      setPreviewFile(previewUrl);
      setShowModal(true);
    } else {
      console.error("Error: Invalid URL for preview.");
    }
    if (names == 1) {
      // console.log("this");
      // console.log(fileInputs);
      const fileData = fileInputs[index].data;
      setFileName({
        exten: fileData.split(".").pop(),
        name: fileInputs[index].fileName,
      });
    } else {
      // console.log("run");
      setFileName({
        exten: names.split(".").pop(),
        name: names,
      });
    }
  }
  const handlePost = () => {
    // if (textAreaValue) { // check if there's a value in the text area
    setPosts(textAreaValue);
    // setTextAreaValue(''); // clear the text area
    // }
  };
  const handleInput = (event) => {
    const words = event.target.value.split(" ");
    const count = words.length;
    setWordCount(count);
    // console.log(event.target.value)
    setTextAreaValue(event.target.value); // save the value of the text area in state
  };

  const handleReadMoreClick = () => {
    setShowFullText(!showFullText);
  };

  const notify = (message, type) => {
    // alert('error', +message)
    type == "success"
      ? toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      })
      : toast.error(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
  };
  const handleDelete = (row) => {
    const filteredData = data4.filter((d) => d.id !== deleteRowId);
    const index = data4.findIndex((d) => d.id === deleteRowId);
    const updatedMaterialId = [
      ...materialId.slice(0, index),
      ...materialId.slice(index + 1),
    ];
    const updatedNames = [...names.slice(0, index), ...names.slice(index + 1)];
    const updatedEmails = [
      ...emails.slice(0, index),
      ...emails.slice(index + 1),
    ];
    const updatedDobs = [...dobs.slice(0, index), ...dobs.slice(index + 1)];
    setdata4(filteredData);
    setMaterialId(updatedMaterialId);
    setNames(updatedNames);
    setEmails(updatedEmails);
    setDobs(updatedDobs);
    setIsOpen5(false);
    notify("Successfully deleted!", "success");
  };
  const handleDelete2 = () => {
    if (selectedRows?.length === 0) {
      return notify("Please select one or more rows to delete", "error");
    }

    const idsToDelete = selectedRows?.map((row) =>
      row.material_id ? row.material_id : row.id
    );
    const newData = data4?.filter(
      (row) => !idsToDelete.includes(row.material_id ? row.material_id : row.id)
    );

    // Remove the corresponding values from the materialId, names, emails, and dobs arrays
    const newMaterialIds = materialId.filter((id) => !idsToDelete.includes(id));
    const newNames = names.filter(
      (_, index) => !idsToDelete.includes(data4[index]?.material?.id)
    );
    const newEmails = emails.filter(
      (_, index) => !idsToDelete.includes(data4[index]?.material?.id)
    );
    const newDobs = dobs.filter(
      (_, index) => !idsToDelete.includes(data4[index]?.material?.id)
    );

    setSelectedRows([]);
    setdata4(newData);
    setMaterialId(newMaterialIds);
    setNames(newNames);
    setEmails(newEmails);
    setDobs(
      newDobs.map((date, index) =>
        idsToDelete.includes(data4[index]?.material?.id) ? "" : date
      )
    );
    setEditApiEnable(false);
    setIsOpen4(false);

    notify("Successfully deleted!", "success");
  };

  const handleDropdownClick = (item) => {
    // setInputValue(`${item.long_text}`);
    const searchItem = secureLocalStorage.getItem("search");
    FetchMaterialSearch(searchItem);
    const isDuplicate = filterCountries.some(
      (existingItem) => existingItem.id === item.id
    );

    if (!isDuplicate) {
      // console.log('inside method')
      setFilterCountries([...filterCountries, item]);
      setFilterCountries2([...filterCountries2, item]);
    } else {
      notify("Material already added");
    }
    setIsOpen(false);
    setShowTable(true);

    inputRef.current.blur();
  };
  const handleDropdownClick2 = () => {
    // navigate to /createimr screen
    navigate("/createimr");
  };

  const createNewPr = () => {
    // alert(filteredData)
    window.scrollTo(0, 0);
    setCreatePr(true);
    setReleaseImr(!releaseImr);
  };
  const EditableTableData = async () => {
    setLoading(true);

    // if (!textAreaValue) {
    //     notify('Comment is required')
    //     setLoading(false);
    //     return;
    // }
    const newData = data4.map((row) => {
      if (row.id === editingRow) {
        return {
          ...row,
          ...editedValues[row.id],
        };
      }
      return row;
    });
    setdata4(newData);
    setShowInputFields(false);
    setEditedValues({});
    setEditingRow(null);
    if (!projectId) {
      return notify("Please select the project");
    } else if (!emails.length || !names.length || !dobs.length) {
      return notify("please fill the required fields", "error");
    } else {
      // const materialIdStrings = materialId.map(id => id.toString());

      let dataFound = false;

      for (let i = 0; i < fileInputs.length; i++) {
        const currentInput = fileInputs[i];

        if (currentInput.data) {
          dataFound = true;
        } else if (dataFound && !currentInput.file) {
          setLoading(false);
          return notify(`File fields can't be empty`, "error");
        }
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + accessToken);
      myHeaders.append("Accept", "application/json");

      var formdata = new FormData();
      formdata.append("project_id", projectId);
      formdata.append("request_id", requestId);
      materialId?.forEach((id) => {
        formdata.append("material_id[]", id);
      });
      names?.forEach((n) => {
        formdata.append("quantity[]", n);
      });
      dobs?.forEach((date) => {
        formdata.append("delivary_date[]", date);
      });
      emails?.forEach((e) => {
        formdata.append("wbs_element[]", e);
      });
      stockLoation?.forEach((e) => {
        formdata.append("stock_location[]", e);
      });
      stockQty?.forEach((e) => {
        formdata.append("stock_quantity[]", e);
      });
      if (deletedImagesId) {
        deletedImagesId?.forEach((d) => {
          // console.log('eeeeeeee',e)
          formdata.append("document_deleted_id[]", d);
        });
      }
      selectedImageArray?.forEach((e) => {
        // console.log("selected", e.file);
        formdata.append("files[]", e.file);
      });
      formdata.append("comment", textAreaValue);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      fetch(
        "https://alhikmahinternational.org/al-asab/public/api/edit/IMR/request",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          setCreateImr(result);
          // console.log('setRequestId',result.data )
          if (result.success == true) {
            setTextAreaValue("");
            setLoading(false);
            setSaveImr(true);

            notify(
              `The IMR, ${result?.data?.request_number} has been updated successfully`,
              "success"
            );
            setImrNo(result?.data?.request_prefix);

            // setUserComment(result?.comments[0]?.comment)
            setUrlArray(result?.data?.documents);
            setdeletedImagesId([]);
            setCreateProjectId(result.data.project_id);
            setCurrentLevel(result.data.current_level);
            setUserFirstName(result?.data?.created_by?.first_name);
            setUserLastName(result?.data?.created_by?.last_name);
            setUserComment(result?.data?.comments);
            setTotalLevel(result.data.projects?.no_of_approval_level);
            setRequestId(result.data.id);
            setStatus(result?.data?.stage);
            // setImrDate(moment(result?.data?.created_at).format('DD-MM-YYYY'))
            const originalDate = result?.data?.created_at;
            const updateDate = result?.data?.comments[0].updated_at;
            const formattedDate = moment(originalDate).format("DD-MM-YYYY");
            const commentDate = moment(updateDate).format("DD-MM-YYYY");

            setImrDate(formattedDate);
            setCommentDate(commentDate);
          } else {
            setLoading(false);
            notify("Something went wrong!", "error");
          }
        })
        .catch((error) => {
          // console.log("error0000->", error);
          setLoading(false);
        });
    }
  };

  const RequestApproval = (status) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + accessToken);

    var formdata = new FormData();
    formdata.append("request_id", requestId);
    formdata.append("status", status);
    formdata.append("current_level", currentLevel);
    formdata.append("project_id", projectId);

    formdata.append("comment", textAreaValue);
    // console.log('textAreaValue', textAreaValue)

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      "https://alhikmahinternational.org/al-asab/public/api/request/approval",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.status) {
          notify(result?.message, "success");
          navigate("/imr-list");
        } else {
          notify(result?.message, "error");
        }
      })
      .catch((error) => console.log("error", error));
  };

  const RequestRply = (id) => {
    if (id == 1) {
      setApproved(true);
      RequestApproval("approved");
    } else if (id == 2) {
      setReject(true);
      RequestApproval("rejected");
    } else if (id == 3) {
      setResubmit(true);
      RequestApproval("resubmit");
    }
  };
  const getUserLevel = () => {
    const run = matchRqstLevel?.projects?.approver?.filter((val) =>
      val?.pivot?.level?.toLowerCase().includes(currentLevel)
    );
    return run;
  };

  const releaseImrMethod = () => {
    setLoading(true);
    window.scrollTo(0, 0);
    releaseArray.push(1);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + accessToken);

    var formdata = new FormData();
    formdata.append("project_id", ceateprojectId);
    formdata.append("current_level", currentLevel);
    formdata.append("total_level", totalLevel);
    formdata.append("request id", requestId);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      "https://alhikmahinternational.org/al-asab/public/api/send/request/approval",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log('relase request--->', result)
        if (result.status) {
          setReleaseImr(true);
          setMatchRqstLevel({ is_released: 1 });
          setLoading(false);
          setReleaseStatus(result?.status);
          setDisableEditButton(false);
          notify(
            `The IMR, ${imrNumber} has been released successfully`,
            "success"
          );
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };
  const defaultDate = new Date().toLocaleDateString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });

  useEffect(() => {
    validate();
  }, [data4, editedValues]);
  const handleSave = () => {
    // Update table data with edited values
    const newData = data4?.map((row) => {
      if (row.id === editingRow) {
        return Object.assign({}, row, editedValues[row.id]);
      }
      return row;
    });
    setdata4(newData);

    // Hide input fields and clear edited values
    setEditedValues({});
    setEditingRow(null);

    // Check if save button should be enabled or disabled
    const errors = validate();
    const hasErrors = Object.keys(errors).length > 0;
    setIsSaveEnabled(!hasErrors);
  };

  useEffect(() => {
    if (selectedRow) {
      setEditedRow(selectedRow);
    }
  }, [selectedRow]);

  const tableRef = useRef(null);

  const exportPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });
    const tableNode = tableRef.current;

    // Get table data as an array of arrays
    const table2 = data4.map((row) => [
      row.id,
      row?.material?.material_type,
      row?.material?.material_category,
      row?.material?.material_code,
      row?.material?.short_text,
      row?.material?.long_text,
      row?.quantity,
      row?.material?.unit,
      row?.delivary_date,
      row?.material?.manufacturer,
      row?.material?.manufacturer_model,
      row?.wbs_element,
      row?.material?.plant,
      row?.stock_location,
      row?.stock_quantity,
      // { content: row?.stock_location.map((item) => console.log(item)).join("\n") },
      // { content: row?.stock_location.map((item) => console.log(item)).join("\n") }
    ]);

    const colsObj = columns2
      .filter((col) => col?.name !== "Quick Actions")
      .map((col) =>
        col?.name?.props?.children[2] ? col?.name?.props?.children[2] : col.name
      );
    const head = [colsObj];
    const didParseCell = function (data) {
      if (data.row.raw[0] === "Quick Actions") {
        data.cell.styles.visibility = "hidden";
      }
    };

    // Set options for autoTable
    const options = {
      head,
      body: table2,
      didParseCell,
    };

    doc.autoTable(options);

    // Save the PDF
    doc.save("table.pdf");
  };

  const printTable = () => {
    const printContents = document.getElementById("myTable").outerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  const CustomPagination = ({ page, perPage, setPage, data }) => {
    const handlePrev = () => {
      if (page > 0) {
        setPage(page - 1);
      }
    };

    const handleNext = () => {
      if (page < Math.ceil(data.length / perPage) - 1) {
        setPage(page + 1);
      }
    };
    return (
      <div className="customPaginationMain">
        <div>
          Showing {page * perPage + 1} to{" "}
          {Math.min(data.length, (page + 1) * perPage)} of {data.length} entries
        </div>
        <div className="PaginationButtonMain">
          <button className="paginationButtons" onClick={handlePrev}>
            Previous
          </button>

          {Array.from({ length: Math.ceil(data.length / perPage) }, (_, i) => {
            if (
              Math.abs(i - page) <= 2 ||
              i === 0 ||
              i === Math.ceil(data.length / perPage) - 1
            ) {
              // Show the current page and the two adjacent pages, or the first and last pages
              return (
                <button
                  key={i}
                  onClick={() => setPage(i)}
                  className={i === page ? "activePage" : "paginationButtons"}
                >
                  {i + 1}
                </button>
              );
            } else if (Math.abs(i - page) === 3) {
              // Show an ellipsis and the last page number
              return <span key={i}>...</span>;
            } else {
              // Don't show this page number
              return null;
            }
          })}
          <button className="paginationButtons" onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
    );
  };

  const CustomPagination2 = ({
    page3,
    perPage3,
    setPage3,
    filteredData,
    handleChangeRowsPerPage,
  }) => {
    const handlePrev = () => {
      if (page3 > 0) {
        setPage3(page3 - 1);
      }
    };

    const handleNext = () => {
      if (page3 < Math.ceil(filteredData.length / perPage3) - 1) {
        setPage3(page3 + 1);
      }
    };

    // Calculate the start and end indices of the current page based on the full data array
    const startIndex = page3 * perPage3;
    const endIndex = Math.min(filteredData.length, (page3 + 1) * perPage3);
    const authModal = secureLocalStorage.getItem("authModal");
    if (authModal) {
      return <UnAuthModal />;
    }
    return (
      <div className="customPaginationMain">
        <div>
          Showing {startIndex + 1} to {endIndex} of {filteredData.length}{" "}
          entries
        </div>
        <div className="PaginationButtonMain">
          <button className="paginationButtons" onClick={handlePrev}>
            Previous
          </button>
          {Array.from(
            { length: Math.ceil(filteredData.length / perPage3) },
            (_, i) => {
              if (
                Math.abs(i - page3) <= 2 ||
                i === 0 ||
                i === Math.ceil(filteredData.length / perPage3) - 1
              ) {
                // Show the current page and the two adjacent pages, or the first and last pages
                return (
                  <button
                    key={i}
                    onClick={() => setPage3(i)}
                    className={i === page3 ? "activePage" : "paginationButtons"}
                  >
                    {i + 1}
                  </button>
                );
              } else if (Math.abs(i - page3) === 3) {
                // Show an ellipsis and the last page number
                return <span key={i}>...</span>;
              } else {
                // Don't show this page number
                return null;
              }
            }
          )}
          <button className="paginationButtons" onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
    );
  };
  const location = useLocation();

  useEffect(() => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    const yyyy = today.getFullYear();
    const currentDate = dd + "-" + mm + "-" + yyyy;
    setCurrntDate(currentDate);
    const myBooleanValue = location.state?.myBooleanValue;
    if (myBooleanValue == 1) {
      setSaveImr(true);
    }
    setBolean(myBooleanValue);
    const actiondata = location.state?.action;
    setAction(actiondata);
    const recievedData = location.state?.data;
    setMatchRqstLevel(recievedData);
    setRequestId(recievedData?.id);
    setRole(recievedData?.role);
    SinglrRequest(recievedData?.id);

    if (myBooleanValue == 1) {
      setSelectedOption(recievedData?.Project);
    }
  }, []);
  function handleCloseModal() {
    setSelectedFiles([]);
    setShowModal(false);
  }

  const createNewImr = () => {
    setShowTable(false);
    setShowTableTwo(false);
    // setSaveImr(false);
    setReleaseImr(false);
    setCreatePr(false);
    setInputValue("");
    setSelectedOption("");
    setFilteredData([]);
    setdata4([]);
    setSelectedImageArray("");
    setPosts("");
    setProjectId("");
    setDobs("");
    setNames("");
    setEmails("");
    setRequiredDeliveryDate([]);
    setMaterialId("");
    setSelectedFiles([null]);
    setFile("");
    setFileInputs([{ id: 0, file: null }]);
  };

  function handleAddInput() {
    setDeleteFile(true);

    setFileInputs([...fileInputs, { id: fileInputs.length, file: null }]);
  }
  // useEffect(() => {
  //     // update selectedImageArray whenever urlArray changes
  //     const newSelectedImageArray = urlArray.map((item, index) => ({ id: index, data: item?.url }));
  //     const selectedInput = urlArray.map((item, index) => ({ id: index, data: item?.url }));
  //     if (selectedInput.length) {
  //         setFileInputs(selectedInput);
  //     }
  //     console.log('selectedInput', selectedInput)
  //     // console.log('newSelectedImageArray--->',newSelectedImageArray)
  //     setSelectedImageArray(newSelectedImageArray);
  //     const names = urlArray.map((item, index) => ({ id: index, name: item.name }));
  //     setFileNames(names);
  // }, [urlArray]);

  // const handleFileInputChange2 = (event, id, index) => {
  //     const file = event.target.files[0];
  //     const fileSizeInMB = file.size / (1024 * 1024); // convert bytes to MB
  //     if (fileSizeInMB > 1) {

  //         notify('The file size has exceeded the limit of 1MB', 'error')
  //         return; // stop further processing
  //     } else {
  //         const newFileInputs = fileInputs.map((fileInput) => {
  //             if (fileInput.id === id) {
  //                 const file = event.target.files[0];
  //                 setFile(file.name);

  //                 setSelectedFiles(file);
  //                 return {
  //                     id,
  //                     file,
  //                     preview: URL.createObjectURL(file),
  //                     fileName: file.name, // store the file name
  //                 };
  //             }
  //             return fileInput;
  //         });

  //         setFileInputs(newFileInputs);
  //         const files = newFileInputs.map((fileInput) => {
  //             return { id: fileInput.id, file: fileInput.data ? fileInput.data : fileInput.file };
  //         }); // extract the file property
  //         // const fileObjects = files.map((file) => ({ file })); // create an array of file objects

  //         setSelectedImageArray(files);
  //     }

  // };

  // function handleRemove(id, index) {
  //     console.log(id)
  //     const up = fileNames.filter((item) => item.id !== id);
  //     setFileNames(up)
  //     const updatedItems = fileInputs.filter((item) => item.id !== id);
  //     setFileInputs(updatedItems)
  //     const updatedarray = selectedImageArray.filter((item) => item.id !== id);
  //     const updatedarray2 = urlArray.filter((item) => item?.url == index);
  //     updatedarray2.forEach((del) => {
  //         deletedImagesId.push(del?.id);
  //     })
  //     setSelectedImageArray(updatedarray)
  // }

  useEffect(() => {
    // update selectedImageArray whenever urlArray changes
    const newSelectedImageArray = urlArray.map((item, index) => ({
      id: index,
      data: item?.url,
    }));
    const selectedInput = urlArray.map((item, index) => ({
      id: index,
      data: item?.url,
    }));

    if (selectedInput.length) {
      setFileInputs(selectedInput);
    }
    // console.log('selectedInput--->', selectedInput)
    setSelectedImageArray(newSelectedImageArray);
    const names = urlArray.map((item, index) => ({
      id: index,
      name: item.name,
    }));
    setFileNames(names);
  }, [urlArray]);

  const handleFileInputChange2 = (event, id, index) => {
    const file = event.target.files[0];
    const fileSizeInMB = file.size / (1024 * 1024); // convert bytes to MB
    if (fileSizeInMB > 1) {
      notify("The file size has exceeded the limit of 1MB", "error");
      return;
    }

    const newFileInputs = fileInputs.map((fileInput, index) => {
      if (index === id) {
        const file = event.target.files[0];
        setFile(file.name);

        setSelectedFiles(file);

        return {
          id,
          file,
          preview: URL.createObjectURL(file),
          fileName: file.name, // store the file name
        };
      }
      return fileInput;
    });

    setFileInputs(newFileInputs);
    const files = newFileInputs.map((fileInput) => {
      return {
        id: fileInput.id,
        file: fileInput.data ? fileInput.data : fileInput.file,
      };
    }); // extract the file property
    // const fileObjects = files.map((file) => ({ file })); // create an array of file objects

    setSelectedImageArray(files);
  };
  const fileOnlyArray = fileInputs.filter((input) => "file" in input);

  function handleRemove(id, index) {
    const up = fileNames.filter((item, index) => index !== id);
    setFileNames(up);
    if (fileInputs.length == 1) {
      if (fileInputs[0]) {
        setFileInputs([{ id: 0, file: null }]);
      }
    } else {
      setFileInputs((prevFileInputs) =>
        prevFileInputs.filter((item, index) => index !== id)
      );
    }

    const updatedarray = selectedImageArray.filter(
      (item, index) => index !== id
    );
    const updatedarray2 = urlArray.filter((item, index) => index == id);
    // setUrlArray(urlArray.filter((item, index) => index != id));
    updatedarray2.forEach((del) => {
      const checkData = deletedImagesId.includes(del.id);
      if (!checkData) {
        deletedImagesId.push(del?.id);
      }
    });

    // deletedImagesId.push(deleteImageArray)
    setSelectedImageArray(updatedarray);
  }

  const handleClearInput = () => {
    setInputValue("");
    // setdata4([]);
    // setShowTable(false);
    // setIsOpen(false);

    inputRef.current.focus();
  };

  const handleOptionSelect = (option, event) => {
    setSelectedOption(option);
    setLevel(option?.no_of_approval_level);
    setProjectId(option?.id);
    setShowOptions(false);
  };

  // styles
  const dropdownStyle = {
    position: "absolute",
    top: "60px",
    width: "80",
    background: "#fff",
    border: "1px solid #ddd",
    maxHeight: "400px",
    overflowY: "auto",
    zIndex: "9999",
  };
  const clearIconStyle = {
    position: "absolute",
    top: "15px",
    right: "30px",
    cursor: "pointer",
  };
  return (
    <div className="imrScreenMain">
      <ToastContainer />

      {loading && (
        <div className="loaderScreen">
          <Puff
            height={80}
            width={80}
            color="rgba(0, 120, 207, 1)"
            ariaLabel="puff-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}
      <Header />
      <div className="headerPosition">
        {/* headerImage */}
        <div className="inner-image">
          <div className="ps-4 pe-4">
            <div className="headerStatus">
              {imrNumber ? (
                <div className="headerImageText1">
                  <p>IMR no:</p>
                  <p>{imrNumber}</p>
                </div>
              ) : (
                ""
              )}

              {!status ? (
                <div className="headerImageInitial">
                  <p>initial</p>
                </div>
              ) : status == "saved" ? (
                <div>
                  {releaseImr ? (
                    <div className="headerImagePending">
                      <p>Pending</p>
                    </div>
                  ) : (
                    <div className="headerImageSaved">
                      <p>Saved</p>
                    </div>
                  )}
                </div>
              ) : status == "pending" ? (
                <div className="headerImagePending">
                  <p>Pending</p>
                </div>
              ) : status == "Approved" ? (
                <div className="headerImageApproved">
                  <p>Approved</p>
                </div>
              ) : status == "Returned" ? (
                <div>
                  {releaseImr ? (
                    <div className="headerImagePending">
                      <p>Pending</p>
                    </div>
                  ) : (
                    <div className="headerImageApproved">
                      <p>Returned</p>
                    </div>
                  )}
                </div>
              ) : status == "Rejected" ? (
                <div className="headerImageInitial">
                  <p>Rejected</p>
                </div>
              ) : null}
            </div>

            <div className="d-flex">
              <div className="headerImageText">
                <p>IMR Date:</p>
                <p>{imrDate}</p>
              </div>
            </div>

            {requestId ? (
              <div>
                <div className="headerImageText3">
                  <p>Created By:</p>
                  <p>
                    {userFirstName} {userLastName}
                  </p>
                </div>

                {role == "Approver" ? (
                  <div className="headerImageText3 ">
                    <p className="mt-0">Project :</p>
                    <p className="mt-0">{selectedOption?.project_name}</p>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : null}
          </div>
          <div className="SearchOnImage">
            <div className="SearchOnImage">
              <div className="onImage-Text">
                {role == "Approver" ? (
                  <h1>
                    View <strong> Submitted Requests</strong>
                  </h1>
                ) : (
                  <h1>
                    Create an<strong> IMR Request</strong>
                  </h1>
                )}

                {/* <p>
                                    Lorem Ipsum is simply dummy text of the printing and
                                    typesetting industry.
                                    <br />
                                    Lorem Ipsum has been the industry's standard dummy text{" "}
                                </p> */}
              </div>
            </div>
          </div>
          {role == "Approver" ? (
            ""
          ) : (
            <div className="container">
              <div className="row">
                <div className="app">
                  <div className="custom-select" ref={dropdownRef} disabled>
                    <div
                      className={
                        selectedOption
                          ? "selected-option2Disabled"
                          : "selected-option"
                      }
                    >
                      {selectedOption ? (
                        <div className="option w-100">
                          <div className="d-flex">
                            {projects?.projects?.map((option) =>
                              option.id === selectedOption.id ? (
                                <img
                                  key={option.project_id}
                                  src={starFill}
                                  alt="starFill"
                                />
                              ) : null
                            )}
                            <span
                              className="ms-2"
                              style={{
                                overflow: "hidden",
                                fontSize: "19px",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 1,
                                WebkitBoxOrient: "vertical",
                                maxWidth: "200px",
                              }}
                            >
                              {selectedOption.project_name}
                            </span>
                          </div>
                          <div>
                            <i
                              className={`fas fa-solid ${showOptions ? "fa-caret-up" : "fa-caret-down"
                                }`}
                            ></i>
                          </div>
                        </div>
                      ) : (
                        <div className="option w-100">
                          <span>Select Project</span>
                          <i
                            className={`fas fa-solid ${showOptions ? "fa-caret-up" : "fa-caret-down"
                              }`}
                          ></i>
                        </div>
                      )}
                    </div>
                    {showOptions && (
                      <div>
                        <div className="options">
                          <h1>All Projects</h1>
                          <table>
                            <thead>
                              <tr className="HeaderDropDown">
                                <th>Name</th>
                                <th className="id">ID</th>
                              </tr>
                            </thead>
                            <tbody className="customtab">
                              {projects?.projects?.map((option) => (
                                <tr
                                  key={option.id}
                                  onClick={() => handleOptionSelect(option)}
                                >
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <i
                                        style={{
                                          position: "relative",
                                          right: "38px",
                                        }}
                                        className={`fa-solid ${selectedOption.id === option.id
                                          ? "fa-check"
                                          : ""
                                          }`}
                                      ></i>
                                      <div className="d-flex align-items-center">
                                        <img src={star} alt="star" />
                                        <div className="ps-2">
                                          {option.project_name}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="optionId">
                                    {option.project_id}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="headerSerachDropDown">
                    <span className="searchIcon">
                      <img width={25} src={Search} alt="search" />
                    </span>
                    {role == "Viewer" ||
                      (role == "User" && action == 1) ||
                      status == "Rejected" ||
                      status == "pending" ||
                      status == "Approved" ||
                      releaseImr ? (
                      <input
                        type="text"
                        placeholder="Search"
                        value={inputValue}
                        onChange={handleInputChange}
                        className="headerSearchInputDisabled"
                        ref={inputRef}
                        disabled
                      />
                    ) : (
                      <input
                        type="text"
                        placeholder="Search"
                        value={inputValue}
                        onChange={handleInputChange}
                        className="headerSearchInput"
                        ref={inputRef}
                      />
                    )}
                    {inputValue !== "" && (
                      <span
                        className="crossSearchIcon"
                        onClick={handleClearInput}
                      >
                        <img src={close} alt="close" />
                      </span>
                    )}
                    {isOpen && inputValue !== "" && (
                      <div
                        ref={dropdownRef2}
                        style={{
                          ...dropdownStyle,
                          width: inputRef.current.offsetWidth,
                          width: "85%",
                        }}
                      >
                        <div className="SearchFilterImrIsr">
                          <img
                            src={filter2}
                            alt="filter2"
                            onClick={handleIconClick}
                          />
                          {isOpen2 && (
                            <div ref={dropdownRef} className="dropdown2">
                              <p
                                className={
                                  selectedOptions2.includes(
                                    "Material Description"
                                  )
                                    ? "selected2"
                                    : ""
                                }
                                onClick={() =>
                                  handleOptionClick("Material Description")
                                }
                              >
                                Material Description
                              </p>

                              <p
                                className={
                                  selectedOptions2.includes("Category")
                                    ? "selected2"
                                    : ""
                                }
                                onClick={() => handleOptionClick("Category")}
                              >
                                Category
                              </p>
                              <p
                                className={
                                  selectedOptions2.includes("Material")
                                    ? "selected2"
                                    : ""
                                }
                                onClick={() => handleOptionClick("Material")}
                              >
                                Material
                              </p>
                            </div>
                          )}
                          {!isOpen2 && (
                            <div className="selectedOption2">
                              {selectedIcons}
                            </div>
                          )}
                        </div>

                        <table style={{ width: "100%" }}>
                          <thead className="ImrTable">
                            <tr>
                              <th>Material Description</th>
                              <th>Category</th>
                              <th>Material Code</th>
                            </tr>
                          </thead>
                          <tbody className="tBodyImr">
                            {FilterMethod().length === 0 ? (
                              <tr>
                                <td colSpan="3">No Result Found</td>
                              </tr>
                            ) : (
                              FilterMethod().map((item) => (
                                <tr
                                  key={item.id}
                                  onClick={() => handleDropdownClick(item)}
                                >
                                  <td>{item.long_text}</td>
                                  <td>{item.material_category}</td>
                                  <td>{item.material_code}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Main-content */}
      <div className="IsrMain">
        {showTable ? (
          <div className="container mb-4 tableIMr">
            <div className="imr-list-table">
              <div className="container">
                <div className="row TableRowImr align-items-center">
                  <div className="searchresultHeader mb-0 col-md-6 ">
                    <h1>Search Results</h1>
                  </div>

                  <div className="col-md-6">
                    <div className="custonDropdownIsr">
                      <div className="col-auto">
                        <div className="dropdown-center">
                          <i
                            className="imr-filter-btn d-inine-block"
                            type="button"
                            data-bs-toggle="dropdown"
                            data-boundary="window"
                            aria-haspopup="true"
                            aria-expanded="false"
                            data-bs-auto-close="outside"
                          >
                            <img
                              src={filterSvg}
                              className="imr-filter-img"
                              height={17}
                              width={26}
                            />
                            <span className="name-filter">Filter</span>
                          </i>

                          <ul
                            className="dropdown-menu filterDropdown"
                            aria-labelledby="dropdownMenuLink"
                          >
                            <li>
                              <div
                                className="accordion accordion-flush"
                                id="accordionFlushExample"
                              >
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="flush-headingOne"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseOne"
                                      aria-expanded="false"
                                      aria-controls="flush-collapseOne"
                                    >
                                      Material Code
                                    </button>
                                  </h2>
                                  <div
                                    id="flush-collapseOne"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingOne"
                                    data-bs-parent="#accordionFlushExample"
                                  >
                                    <div className="accordion">
                                      <div
                                        className={`accordion-body ${isOpen ? "is-open" : ""
                                          }`}
                                      >
                                        <div className="accordingScroll">
                                          <ul className="accordionlist me-0 ps-0">
                                            {filterCountries
                                              ?.filter(
                                                (item, index, self) =>
                                                  index ===
                                                  self.findIndex(
                                                    (t) =>
                                                      t.material_code &&
                                                      t.material_code ===
                                                      item.material_code
                                                  )
                                              )
                                              .map((item) => (
                                                <li
                                                  className="accordionlistItem"
                                                  key={item.material_code}
                                                  onClick={() =>
                                                    handleMaterialCodeAccordionItemClick(
                                                      item
                                                    )
                                                  }
                                                >
                                                  <div>
                                                    <p>{item.material_code}</p>
                                                  </div>
                                                </li>
                                              ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="flush-headingTwo"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseTwo"
                                      aria-expanded="false"
                                      aria-controls="flush-collapseTwo"
                                    >
                                      Class
                                    </button>
                                  </h2>
                                  <div
                                    id="flush-collapseTwo"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingTwo"
                                    data-bs-parent="#accordionFlushExample"
                                  >
                                    <div className="accordion">
                                      <div
                                        className={`accordion-body ${isOpen ? "is-open" : ""
                                          }`}
                                      >
                                        <div className="accordingScroll">
                                          <ul className="accordionlist me-0 ps-0">
                                            {filterCountries
                                              ?.filter(
                                                (item, index, self) =>
                                                  index ===
                                                  self.findIndex(
                                                    (t) =>
                                                      t.class &&
                                                      t.class === item.class
                                                  )
                                              )
                                              .map((item) => (
                                                <li
                                                  className="accordionlistItem"
                                                  key={item.class}
                                                  onClick={() =>
                                                    handleClassAccordionItemClick(
                                                      item
                                                    )
                                                  }
                                                >
                                                  <div>
                                                    <p>{item.class}</p>
                                                  </div>
                                                </li>
                                              ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id="flush-headingThree"
                                  >
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseThree"
                                      aria-expanded="false"
                                      aria-controls="flush-collapseThree"
                                    >
                                      Short Text
                                    </button>
                                  </h2>
                                  <div
                                    id="flush-collapseThree"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="flush-headingThree"
                                    data-bs-parent="#accordionFlushExample"
                                  >
                                    <div className="accordion">
                                      <div
                                        className={`accordion-body ${isOpen3 ? "is-open" : ""
                                          }`}
                                      >
                                        <div className="accordingScroll">
                                          <ul className="accordionlist me-0 ps-0">
                                            {filterCountries
                                              ?.filter(
                                                (item, index, self) =>
                                                  index ===
                                                  self.findIndex(
                                                    (t) =>
                                                      t.short_text &&
                                                      t.short_text ===
                                                      item.short_text
                                                  )
                                              )
                                              .map((item) => (
                                                <li
                                                  className={`accordionlistItem ${selectedOption3 ===
                                                    item.short_text
                                                    ? "selected"
                                                    : ""
                                                    }`}
                                                  key={item.class}
                                                  onClick={() =>
                                                    handleShortTextAccordionItemClick(
                                                      item
                                                    )
                                                  }
                                                >
                                                  <div>
                                                    <p>{item.short_text}</p>
                                                  </div>
                                                </li>
                                              ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-auto">
                        <div className="searchresultHeader-imr">
                          Search:
                          <input
                            type="text"
                            onChange={(e) => setSearch(e.target.value)}
                            className="SearchResult"
                          />
                        </div>
                      </div>
                      <div className="col-auto">
                        {createPr ? (
                          <button
                            onClick={() => createNewImr()}
                            className="saveISR-btn"
                          >
                            Create New IMR
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="datatable-imr">
              <div className="datatable-imr">
                {filterCountries.length > 0 && (
                  <div>
                    <DataTable
                      sortIcon={
                        <div className="sort-icon">
                          {customSortIcon(sortDirection)}
                        </div>
                      }
                      onSort={handleSort}
                      sortColumn={sortColumn}
                      sortDirection={sortDirection}
                      striped
                      responsive
                      columns={columns}
                      // data={filterCountries}
                      data={filterCountries
                        ?.filter(
                          (item) =>
                            (!selectedMaterialCode ||
                              item.material_code ===
                              selectedMaterialCode.material_code) &&
                            (!selectedClass ||
                              item.class === selectedClass.class) &&
                            (!selectedShortText ||
                              item.short_text === selectedShortText.short_text)
                        )
                        .slice(page * perPage, (page + 1) * perPage)}
                      pagination
                      fixedHeader
                      fixedHeaderScrollHeight="450px"
                      selectableRowsHighlight
                      highlightOnHover
                      value={search}
                      paginationComponent={() => (
                        <CustomPagination
                          page={page}
                          perPage={perPage}
                          setPage={setPage}
                          data={filterCountries}
                        />
                      )}
                      paginationPerPage={perPage}
                      paginationResetDefaultPage={true}
                      paginationPage={page}
                      onChangePage={(p) => { }}
                      onChangeRowsPerPage={(pp) => setPerPage(pp)}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        <>
          <div className="mt-5 mb-5 ms-4 me-4 tableTwoImr">
            <h1 className="">Selected Materials</h1>
            <div className="searchresultHeader2">
              <div>
                <div className="rowsPerPage">
                  show
                  <select
                    className="showperPage"
                    value={perPage3}
                    onChange={handleChangeRowsPerPage}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                  </select>
                  entries
                </div>
              </div>
              <div className="selected-materialMain">
                {(status != "saved" && role != "Viewer") || releaseImr ? (
                  status != "Rejected" ? (
                    <ReactToPrint
                      trigger={() => (
                        <button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                        >
                          <img src={printImr} alt="print" />
                        </button>
                      )}
                      content={() => componentRef.current}
                    />
                  ) : (
                    <button
                      style={{ backgroundColor: "transparent", border: "none" }}
                    >
                      <img src={printImrDisable} alt="print" />
                    </button>
                  )
                ) : (
                  <button
                    style={{ backgroundColor: "transparent", border: "none" }}
                  >
                    <img src={printImrDisable} alt="print" />
                  </button>
                )}

                {(status != "saved" && role != "Viewer") || releaseImr ? (
                  status != "Rejected" ? (
                    <img
                      className=" my-element"
                      data-tooltip-content="Download Request"
                      src={pdfImr}
                      style={{ width: 30 }}
                      onClick={() => exportPDF()}
                      alt="pdf"
                    />
                  ) : (
                    <img style={{ width: 30 }} src={disablepdfImr} alt="pdf" />
                  )
                ) : (
                  <img style={{ width: 30 }} src={disablepdfImr} alt="pdf" />
                )}
                {role == "Approver" ? (
                  ""
                ) : status == "Rejected" ||
                  role == "Viewer" ||
                  status == "Approved" ||
                  (role == "User" && action == 1) ||
                  status == "pending" ||
                  releaseImr ? (
                  <button className="deleteISRDisabled-btn">Delete</button>
                ) : (
                  <button onClick={openModal} className="deleteISR-btn">
                    Delete
                  </button>
                )}

                {modalIsOpen ? (
                  <div className="deleteAccountMain">
                    <Modal
                      isOpen={modalIsOpen}
                      onAfterOpen={afterOpenModal}
                      onRequestClose={closeModal}
                      style={customStyles}
                      contentLabel="Example Modal"
                    >
                      <div className="delModelHeader">
                        <h2>Delete Confirmation</h2>
                        <div class="horizontal-line"></div>
                        <p>
                          {" "}
                          Are you sure you want to delete
                          {selectedRows.length > 1
                            ? ` these ${selectedRows.length} `
                            : " this "}
                          {selectedRows.length > 1 ? "materials" : "material"}?
                        </p>
                        <div className="modal-button">
                          <button
                            onClick={() => handleDelete2()}
                            className="delAccountOkButton d-flex align-items-center justify-content-center"
                          >
                            Ok
                          </button>
                          <button
                            onClick={closeModal}
                            className="delAccountCancelButton d-flex align-items-center justify-content-center"
                          >
                            cancel
                          </button>
                        </div>
                      </div>
                    </Modal>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="large-table" id="myTable">
              <div ref={componentRef}>
                <DataTable
                  sortIcon={
                    <div className="sort-icon">
                      {customSortIcon(sortDirection)}
                    </div>
                  }
                  onSort={handleSort}
                  sortColumn={sortColumn}
                  sortDirection={sortDirection}
                  striped
                  responsive
                  columns={columns2}
                  // data={data4}
                  data={data4?.slice(page3 * perPage3, (page3 + 1) * perPage3)}
                  pagination
                  paginationPerPage={perPage3}
                  paginationRowsPerPageOptions={[5, 10, 25]}
                  paginationComponent={() => (
                    <CustomPagination2
                      page3={page3}
                      perPage3={perPage3}
                      setPage3={setPage3}
                      filteredData={data4}
                      handleChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  )}
                  fixedHeader
                  selectableRowsHighlight
                  selectableRows={
                    status == "Rejected" ||
                      role == "Approver" ||
                      role == "Viewer" ||
                      status == "Approved" ||
                      (role == "User" && action == 1) ||
                      status == "pending" ||
                      releaseImr
                      ? false
                      : true
                  }
                  onSelectedRowsChange={({ selectedRows }) =>
                    setSelectedRows(selectedRows)
                  }
                  highlightOnHover
                  ref={tableRef}
                />
              </div>
            </div>

            {data4?.length > 0 && (
              <div>
                <div>
                  <div className="ISRBottom-section pt-3">
                    <div className="iSRUpload-main">
                      <div className="d-flex justify-content-between headerStatus">
                        <div className="position-relative">
                          {fileInputs?.map((item, index) => (
                            <div
                              className="uploadandPriviewMain mt-3"
                              key={index}
                            >
                              <input
                                type="text"
                                // placeholder={fileNames[index]?.name}
                                disabled
                                className="iSR-UploadInput"
                                value={
                                  item.fileName
                                    ? item.fileName
                                    : fileNames.length
                                      ? fileNames[index]?.name
                                      : !item.file
                                        ? "No file uploaded"
                                        : ""
                                } // Update the input value
                              />
                              {/* {alert(status)} */}
                              {role == "Approver" ? (
                                ""
                              ) : status == "Rejected" ||
                                role == "Viewer" ||
                                status == "Approved" ||
                                (role == "User" && action == 1) ||
                                status == "pending" ||
                                releaseImr ? (
                                <label
                                  htmlFor="file-input-0"
                                  className="file-input-labelDisable"
                                >
                                  <input
                                    id="file-input-0"
                                    disabled
                                    type="file"
                                    accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,application/pdf,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.ppt,.pptx,application/vnd.ms-powerpoint,image/bmp,image/png,image/jpg,image/jpeg"
                                    onChange={(e) =>
                                      handleFileInputChange2(e, 0)
                                    }
                                    style={{ display: "none" }}
                                  />
                                  upload
                                </label>
                              ) : (
                                <label
                                  htmlFor={`file-input-${index}`}
                                  className="file-input-label"
                                >
                                  <input
                                    id={`file-input-${index}`}
                                    type="file"
                                    accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,application/pdf,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.ppt,.pptx,application/vnd.ms-powerpoint,image/bmp,image/png,image/jpg,image/jpeg"
                                    onChange={(e) =>
                                      handleFileInputChange2(e, index)
                                    }
                                    style={{ display: "none" }}
                                  />
                                  upload
                                </label>
                              )}

                              <div className="priviewButton">
                                <div>
                                  {role == "Approver" ? (
                                    ""
                                  ) : status == "Rejected" ||
                                    status == "Approved" ||
                                    role == "Viewer" ||
                                    (role == "User" && action == 1) ||
                                    status == "pending" ||
                                    releaseImr ? (
                                    <img
                                      src={delDisable}
                                      style={{ padding: 10 }}
                                    />
                                  ) : (
                                    <>
                                      {deleteFile && index == 0 ? (
                                        fileInputs.length == 1 ? (
                                          <img
                                            onClick={() =>
                                              handleRemove(index, item?.data)
                                            }
                                            src={del}
                                            style={{ padding: 10 }}
                                            className=" my-element"
                                            data-tooltip-content="Delete File"
                                          />
                                        ) : (
                                          <img
                                            src={delDisable}
                                            style={{ padding: 10 }}
                                          />
                                        )
                                      ) : (
                                        <img
                                          onClick={() =>
                                            handleRemove(index, item?.data)
                                          }
                                          src={del}
                                          style={{ padding: 10 }}
                                          className=" my-element"
                                          data-tooltip-content="Delete File"
                                        />
                                      )}
                                    </>
                                  )}
                                </div>
                                <div>
                                  {item.data ? (
                                    <img
                                      onClick={() =>
                                        handlePreviewClick(item.data, index, 1)
                                      }
                                      src={eye}
                                      style={{ padding: 10 }}
                                      className=" my-element"
                                      data-tooltip-content="Preview File"
                                    />
                                  ) : (
                                    item?.file && (
                                      <img
                                        onClick={() =>
                                          handlePreviewClick(
                                            item.preview,
                                            index,
                                            item.fileName ? item.fileName : ""
                                          )
                                        }
                                        src={eye}
                                        style={{ padding: 10 }}
                                        className=" my-element"
                                        data-tooltip-content="Preview File"
                                      />
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                          <div className="d-flex align-items-center">
                            <div
                              className="position-absolute"
                              style={
                                fileInputs.length
                                  ? { top: "17px", right: "-40px" }
                                  : { top: "-10px", right: "-40px" }
                              }
                            >
                              {status == "Rejected" ||
                                role == "Approver" ||
                                role == "Viewer" ||
                                (role == "User" && action == 1) ||
                                status == "Approved" ||
                                status == "pending" ||
                                releaseImr ? null : !releaseImr && !createPr ? (
                                  <div>
                                    {fileOnlyArray.length == 0 ? (
                                      <>
                                        <img
                                          onClick={handleAddInput}
                                          src={add}
                                          style={{ padding: 10 }}
                                          className="my-element"
                                          data-tooltip-content="Add More File"
                                        />
                                      </>
                                    ) : fileInputs[fileInputs.length - 1].file ? (
                                      <>
                                        <img
                                          onClick={handleAddInput}
                                          src={add}
                                          style={{ padding: 10 }}
                                          className="my-element"
                                          data-tooltip-content="Add More File"
                                        />
                                      </>
                                    ) : (
                                      <img
                                        src={addDisable}
                                        style={{ padding: 10 }}
                                      />
                                    )}
                                  </div>
                                ) : (
                                <div>
                                  <img
                                    src={addDisable}
                                    style={{ padding: 10 }}
                                  />
                                </div>
                              )}
                            </div>

                            {!fileInputs.length && (
                              <div>
                                <p className="fs-6">Click here to add file</p>
                              </div>
                            )}
                          </div>

                          <Modal
                            isOpen={showModal}
                            onRequestClose={handleCloseModal}
                            style={{
                              content: {
                                width: "800px", // Set the desired width
                                height: "560px", // Set the desired height
                                margin: "auto", // Center the modal horizontally
                              },
                            }}
                          >
                            <div
                              style={{ cursor: "pointer", float: "right" }}
                              onClick={handleCloseModal}
                            >
                              <i class="fas fa-times fs-5"></i>
                            </div>
                            {previewFile ? (
                              <div style={{ float: "left", width: "100%" }}>
                                {fileName.exten === "jpg" ||
                                  fileName.exten === "jpeg" ||
                                  fileName.exten === "png" ||
                                  fileName.exten === "bmp" ? (
                                  <img
                                    src={previewFile}
                                    alt="preview"
                                    style={{
                                      width: "100%",
                                      height: "480px",
                                      objectFit: "contain",
                                      marginTop: "10px",
                                    }}
                                  />
                                ) : fileName.exten === "pdf" ? (
                                  <iframe
                                    src={previewFile}
                                    title="preview"
                                    style={{
                                      width: "100%",
                                      height: "450px",
                                      objectFit: "contain",
                                      marginTop: "10px",
                                    }}
                                  ></iframe>
                                ) : (
                                  <div
                                    style={{
                                      position: "absolute",
                                      left: "35%",
                                      right: 0,
                                      top: "45%",
                                      bottom: 0,
                                    }}
                                  >
                                    <a
                                      className="btn btn-primary downloadButton"
                                      href={previewFile}
                                      download
                                    >
                                      Download {fileName.names}
                                    </a>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="noImage">
                                <div>
                                  <img
                                    style={{ width: "300px" }}
                                    src={noImage}
                                    alt="noImage"
                                  />
                                </div>
                                <div>
                                  <p>No image found</p>
                                </div>
                              </div>
                            )}
                          </Modal>
                        </div>
                        <div className="custom-file"></div>
                      </div>

                      {role == "Approver" ? (
                        ""
                      ) : fileInputs.length ? (
                        <div className="mt-2">
                          <p>. Accepted File: doc, pdf, xlsx, ppt, bmp, png</p>
                          <p>. File Size doesn’t exceed 1MB</p>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {matchRqstLevel?.is_released == 1 ? (
                      <div className="RealsedByText pt-3">
                        <p>
                          Released By:{" "}
                          <span>
                            {userFirstName} {userLastName}
                          </span>{" "}
                        </p>
                        <p className="mb-0">
                          Released on:<span>{imrDate}</span>
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                  {!releaseImr && !createPr ? (
                    <div class="mb-3" className="isISRCommentMain">
                      <div className="iSRCommentBox">
                        <label
                          for="exampleFormControlTextarea1"
                          class="form-label"
                        >
                          <div className="tableHeaders">Comment</div>
                        </label>
                        <p className="text-muted text-right ">
                          {textAreaValue.length}/1000
                        </p>
                      </div>
                      <div className="row">
                        <div className="col-md-11 form-group">
                          {status != "Rejected" ? (
                            <textarea
                              onChange={handlePost}
                              className="form-control"
                              aria-setsize={20}
                              rows="4"
                              maxLength="1000"
                              onInput={handleInput}
                              value={textAreaValue}
                            ></textarea>
                          ) : (
                            <textarea
                              disabled
                              className="form-control"
                              aria-setsize={20}
                              rows="4"
                              maxLength="1000"
                              onInput={handleInput}
                              value={textAreaValue}
                            ></textarea>
                          )}
                        </div>

                        {/* {userComment[0].comment ? (
                          <div className="col-md-1">
                            <div
                              style={{ marginTop: 90 }}
                              className="d-flex align-Items-center"
                            >
                              {status == "Rejected" ||
                              role == "Approver" ||
                              role == "Viewer" ||
                              status == "Approved" ||
                              (role == "User" && action == 1) ||
                              status == "pending" ||
                              releaseImr ? (
                                <img
                                  className="editImageIcon "
                                  src={editImagedisable}
                                  style={{ width: 25 }}
                                  alt="editImage"
                                />
                              ) : (
                                <img
                                  onClick={() =>
                                    setTextAreaValue(
                                      userComment[0].comment.replace(/\n/g, "")
                                    )
                                  }
                                  className="editImageIcon my-element"
                                  data-tooltip-content="Edit comment"
                                  src={editImage}
                                  alt="editImage"
                                />
                              )}

                              {status == "Rejected" ||
                              role == "Approver" ||
                              role == "Viewer" ||
                              status == "Approved" ||
                              (role == "User" && action == 1) ||
                              status == "pending" ||
                              releaseImr ? (
                                <img
                                  className="editImageIcon"
                                  src={delDisable}
                                  alt="trash"
                                />
                              ) : (
                                <img
                                  onClick={() => setTextAreaValue("")}
                                  className="editImageIcon my-element"
                                  data-tooltip-content="Clear comment"
                                  src={trash}
                                  alt="trash"
                                />
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className="col-md-1">
                            <div
                              style={{ marginTop: 90 }}
                              className="d-flex align-Items-center"
                            >
                              <img
                                src={editImagedisable}
                                style={{ width: 25 }}
                                alt="editImage"
                              />

                              <img
                                className="editImageIcon"
                                src={delDisable}
                                alt="trash"
                              />
                            </div>
                          </div>
                        )} */}
                      </div>
                    </div>
                  ) : (
                    <div class="mb-3" className="isISRCommentMain">
                      <div className="iSRCommentBox">
                        <label
                          for="exampleFormControlTextarea1 commentDiable"
                          class="form-label"
                        >
                          Comment *
                        </label>
                        <p className="text-muted text-right countDisable">
                          {textAreaValue.length}/1000
                        </p>
                      </div>
                      <div className="form-group">
                        <textarea
                          disabled
                          className="form-control"
                          aria-setsize={20}
                          rows="4"
                          maxLength="1000"
                          onInput={handleInput}
                          value={textAreaValue}
                        ></textarea>
                      </div>
                    </div>
                  )}
                </div>
                {role == "Approver" ? (
                  <div className="iSRBtnMain  mt-4">
                    {getUserLevel().map((fil, index) =>
                      userID == fil?.pivot?.user_id &&
                        matchRqstLevel?.is_released == 1 ? (
                        <>
                          {status != "Approved" ? (
                            status != "Rejected" ? (
                              status != "saved" ? (
                                !reject && !resubmit && !approved ? (
                                  <button
                                    onClick={() => RequestRply(1)}
                                    className="buttonSave"
                                  >
                                    Approve
                                  </button>
                                ) : (
                                  <button
                                    disabled
                                    className="saveDisableISR-btn"
                                  >
                                    Approve
                                  </button>
                                )
                              ) : (
                                <button disabled className="saveDisableISR-btn">
                                  Approve
                                </button>
                              )
                            ) : (
                              <button disabled className="saveDisableISR-btn">
                                Approve
                              </button>
                            )
                          ) : (
                            <button disabled className="saveDisableISR-btn">
                              Approve
                            </button>
                          )}
                          {status != "Approved" ? (
                            status != "Rejected" ? (
                              status != "saved" ? (
                                !reject && !resubmit && !approved ? (
                                  <button
                                    onClick={() => RequestRply(2)}
                                    className="buttonSave"
                                  >
                                    Reject
                                  </button>
                                ) : (
                                  <button
                                    disabled
                                    className="saveDisableISR-btn"
                                  >
                                    Reject
                                  </button>
                                )
                              ) : (
                                <button disabled className="saveDisableISR-btn">
                                  Reject
                                </button>
                              )
                            ) : (
                              <button disabled className="saveDisableISR-btn">
                                Reject
                              </button>
                            )
                          ) : (
                            <button disabled className="saveDisableISR-btn">
                              Reject
                            </button>
                          )}
                          {status != "Approved" ? (
                            status != "Rejected" ? (
                              status != "saved" ? (
                                !reject && !resubmit && !approved ? (
                                  <button
                                    onClick={() => RequestRply(3)}
                                    className="buttonSave"
                                  >
                                    Revise & Resubmit
                                  </button>
                                ) : (
                                  <button
                                    disabled
                                    className="saveDisableISR-btn"
                                  >
                                    Revise & Resubmit
                                  </button>
                                )
                              ) : (
                                <button disabled className="saveDisableISR-btn">
                                  Revise & Resubmit
                                </button>
                              )
                            ) : (
                              <button disabled className="saveDisableISR-btn">
                                Revise & Resubmit
                              </button>
                            )
                          ) : (
                            <button disabled className="saveDisableISR-btn">
                              Revise & Resubmit
                            </button>
                          )}
                        </>
                      ) : (
                        <>
                          <button disabled className="saveDisableISR-btn">
                            Approve
                          </button>
                          <button disabled className="saveDisableISR-btn">
                            Reject
                          </button>
                          <button disabled className="saveDisableISR-btn">
                            Revise & Resubmit
                          </button>
                        </>
                      )
                    )}
                  </div>
                ) : (
                  <div className="iSRBtnMain">
                    {
                      // role != "User" && action == 0 ?
                      role != "Viewer" ? (
                        !releaseImr ? (
                          (!createPr && status == "saved") ||
                            status == "Returned" ||
                            status == "Returned" ? (
                            <button
                              disabled={!isSaveEnabled}
                              onClick={() => EditableTableData()}
                              className="buttonSave"
                            >
                              Save
                            </button>
                          ) : (
                            <button className="saveDisableISR-btn">Save</button>
                          )
                        ) : (
                          <button className="saveDisableISR-btn">Save</button>
                        )
                      ) : (
                        <button className="saveDisableISR-btn">Save</button>
                      )
                      // :
                      // <button className="saveDisableISR-btn">Save</button>
                    }
                    {saveImr ? ReleaseButtonMethod(level) : ""}

                    {role != "Viewer" ? (
                      status == "Approved" ? (
                        <button
                          onClick={() =>
                            notify(
                              "This Feature Will Be Implemented In Next Iteration",
                              "success"
                            )
                          }
                          className="createPrISR-btn"
                        >
                          Create PR
                        </button>
                      ) : (
                        <button disabled className="createPrDisabledISR-btn">
                          Create PR
                        </button>
                      )
                    ) : (
                      <button disabled className="createPrDisabledISR-btn">
                        Create PR
                      </button>
                    )}
                  </div>
                )}

                {userComment?.length ? (
                  <div className="commentsMain">
                    <div
                      style={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <div>
                        <h2>{"All Comments"}</h2>
                        {userComment.map((item) => (
                          <>
                            <div className="usersComments">
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <h3>
                                  {item.user.first_name} {item.user.last_name}
                                </h3>
                                <h4>
                                  {moment(item.updated_at).format("DD-MM-YYYY")}{" "}
                                  <br />{" "}
                                  {moment(item.updated_at).format("HH:mm:ss")}
                                </h4>
                              </div>
                              <div
                                style={{
                                  alignItems: "center",
                                  wordWrap: "break-word",
                                  lineHeight: 1.3,
                                }}
                              >
                                <p
                                  style={{
                                    marginRight: "10px",
                                    marginBottom: "0",
                                    lineHeight: 1.3,
                                  }}
                                >
                                  {showFullText
                                    ? item?.comment
                                    : item?.comment.slice(0, 100)}
                                </p>
                                {item.comment.length > 100 && (
                                  <div onClick={handleReadMoreClick}>
                                    <h5>
                                      {" "}
                                      {showFullText ? "Read Less" : "Read More"}
                                    </h5>
                                  </div>
                                )}
                              </div>
                            </div>
                          </>
                        ))}
                      </div>
                      <div style={{ flex: 1 }}></div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        </>
        {/* )} */}
      </div>
      <Tooltip anchorSelect=".my-element" type="dark" effect="solid" />
      <Footer />
    </div>
  );
};

export default ViewImr;
